export default {
  UserId: '',
  Token: '',
};
